import { Card, Typography, Tooltip } from "antd";
import { ShoppingOutlined, DollarOutlined, WalletOutlined, ClockCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;
export default function ProductosCards({ productos = [] }) {

  const totalProductos = productos.length;
  const totalCOP = productos.reduce(
    (acc, p) => acc + (Number(p.valor_unitario_COP) || 0),
    0
  );

  const totalUSD = productos.reduce(
    (acc, p) => acc + (Number(p.valor_unitario_USD) || 0),
    0
  );

  const pendientes = productos.filter(p => {
    const estado = p.estado?.toLowerCase().trim();
    return estado === "open" || estado === "pending";
  }).length;

  const entregados = productos.filter(p => {
    const estado = p.estado?.toLowerCase().trim();
    return estado === "finally closed" || estado === "closed";
  }).length;

  const formatNumber = (num) =>
    new Intl.NumberFormat("es-CO").format(num);

  const formatCompact = (num) => {

    if (num >= 1000000000) return (num / 1000000000).toFixed(1) + "B";
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";

    return num;

  };

  const cards = [
    {
      title: "Productos",
      value: totalProductos,
      description: "Cantidad total de productos registrados",
      icon: <ShoppingOutlined />,
      color: "#1677ff"
    },
    {
      title: "Valor COP",
      value: totalCOP,
      description: "Valor total del inventario en pesos colombianos",
      icon: <DollarOutlined />,
      color: "#52c41a"
    },
    {
      title: "Valor USD",
      value: totalUSD,
      description: "Valor total del inventario en dólares",
      icon: <WalletOutlined />,
      color: "#722ed1"
    },
    {
      title: "Pendientes",
      value: pendientes,
      description: "Productos pendientes por entrega",
      icon: <ClockCircleOutlined />,
      color: "#faad14"
    },
    {
      title: "Entregados",
      value: entregados,
      description: "Productos que ya fueron entregados",
      icon: <CheckCircleOutlined />,
      color: "#13c2c2"
    }
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 24
      }}
    >
      {cards.map((card, i) => (
        <Card
          key={i}
          hoverable
          style={{
            flex: 1,
            borderRadius: 12,
            padding: 14,
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            transition: "all .2s"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div>
              <Text
                style={{
                  color: "#6b7280",
                  fontSize: 13,
                  display: "block",
                  marginBottom: 6
                }}
              >
                {card.title}
              </Text>
              <Tooltip
                title={`${card.description}: ${formatNumber(card.value)}`}
              >
                <div
                  style={{
                    fontSize: 26,
                    fontWeight: 700,
                    color: "#111827",
                    cursor: "help"
                  }}
                >
                  {formatCompact(card.value)}
                </div>
              </Tooltip>
            </div>
            <div
              style={{
                background: card.color + "20",
                color: card.color,
                width: 48,
                height: 48,
                borderRadius: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 22
              }}
            >
              {card.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );

}